import Swal from "sweetalert2";
import { types } from "../../types/types";
import { getCity } from "../city/City";
import { canChangeCities } from "../../helpers/userPermissions";

export const setMap = (data) => ({
  type: types.setMap,
  payload: data,
});

export const uiOpenModal = () => ({
  type: types.uiOpenModal,
});

export const uiCloseModal = () => ({
  type: types.uiCloseModal,
});

export const setCityCode = (data) => ({
  type: types.setCity,
  payload: data,
});

export const changeCityCode = (cityId) => {
  return (dispatch, getState) => {
    const { auth } = getState();
    if (!canChangeCities(auth)) {
      console.warn("Usuario con restricciones no puede cambiar de ciudad");
      return;
    }

    dispatch(setCityCode(cityId));
  };
};

export const setCoverage = (data) => ({
  type: types.setCoverage,
  payload: data,
});

export const setUserCity = (userCityId) => {
  return async (dispatch) => {
    try {
      const cities = await getCity();
      const userCity = cities.find((city) => city.id === userCityId);
      if (userCity) {
        dispatch(setCityCode(userCityId));
        localStorage.setItem("city", JSON.stringify(userCity));
      } else {
        console.log(
          `Ciudad con ID ${userCityId} no encontrada, usando ciudad por defecto`
        );
      }
    } catch (error) {
      console.error("Error al establecer la ciudad del usuario:", error);
    }
  };
};

export const loaddingPageShow = () => ({
  type: types.loaddingPageShow,
});

export const loaddingPageNone = () => ({
  type: types.loaddingPageNone,
});

export const showDriverOrders = (data) => ({
  type: types.showOrdersDriver,
  payload: data,
});

export const getShowDriverFree = (data) => ({
  type: types.showDriverFree,
  payload: data,
});

export const getShowDriverBusy = (data) => ({
  type: types.showDriverBusy,
  payload: data,
});

export const getShowOrdersInProccess = (data) => ({
  type: types.showOrdersInProccess,
  payload: data,
});

export const getShowOrdersReady = (data) => ({
  type: types.showOrdersReady,
  payload: data,
});

export const getShowOrdersDispatched = (data) => ({
  type: types.showOrdersDispatched,
  payload: data,
});

export const getShowOrdersAssigned = (data) => ({
  type: types.showOrdersAssigned,
  payload: data,
});

export const getShowOrdersDispatchedMarker = (data) => ({
  type: types.showOrdersDispatchedMarker,
  payload: data,
});

export const getShowOrdersUnassigned = (data) => ({
  type: types.showOrdersUnassigned,
  payload: data,
});

export const changeIsShowGroup = () => ({
  type: types.showGroup,
});

export const switchOffAllTop = () => ({
  type: types.offAllSwitchTop,
});

export const switchOffAllButtom = () => ({
  type: types.offAllSwitchButtom,
});

export const setShowVehicleType = (data) => ({
  type: types.showVehicleType,
  payload: data,
});

export const setActiveTapPanelLeft = (data) => ({
  type: types.tapPanelLeftActive,
  payload: data,
});

export const setActiveTapPanelRight = (data) => ({
  type: types.tapPanelRightActive,
  payload: data,
});

export const setTipSelected = (data) => ({
  type: types.uiSetTipSelected,
  payload: data
});

export const isShowAveragedriversOrders = () => ({
  type: types.isShowAverageOrders,
});

export const acceptOrdersActive = (data) => ({
  type: types.acceptsOrdersActive,
  payload: data,
});

export const sonarReclamo = () => {
  return async (dispatch, getState) => {
    const { reclamos } = getState().reclamos;
    const statusFilter = reclamos.filter(
      (reclamo) => reclamo.status === "pending"
    );
    if (statusFilter.length > 0) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Ir a reclamos",
        confirmButtonColor: "#7de2a5",
        cancelButtonColor: "#ff9999",
        cancelButtonText: "Cerrar",
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "warning",
        title: statusFilter.length + " RECLAMO(S).",
      }).then(async (result) => {
        if (result.isConfirmed) {
          /* btnReclamoInfo */
          const btnReclamo3 = document.querySelector("#btnReclamoInfo");
          btnReclamo3.click();
        }
      });
      const btnReclamo2 = document.querySelector("#boton_click_play2");
      btnReclamo2.click();
      return Toast;
    }
  };
};

export const sendVerifyWpService = async () => {
  const rpta = await fetch(
    "https://client-wp.patiodelivery2.com/group/sendmessage/SOPORTE PATIOSERVICE",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ message: "test message service" }),
    }
  );
  return rpta.json();
};
